<template>
  <b-overlay :show="loading">
    <div class="mb-0 px-5">
      <BatchFormField name="Subasta">
        <template v-slot:content>
          #{{ batch.subasta.folio }} del {{ formatDate(batch.subasta.fechaSubasta) }}
        </template>
      </BatchFormField>
      <BatchFormField name="Aduana Loteadora" v-if="batch.loteadora.nombre">
        <template v-slot:content>{{ batch.loteadora.nombre }}</template>
      </BatchFormField>
      <BatchFormField name="Aduana Coordinadora" v-if="batch.subasta.gestora.fantasia">
        <template v-slot:content>{{ batch.subasta.gestora.fantasia }}</template>
      </BatchFormField>
      <BatchFormField data-cy="minimum-amount" name="Monto mínimo">
        <template v-slot:content>$ {{ batch.montoMinimo | amount }}</template>
      </BatchFormField>
      <vs-divider></vs-divider>
      <b-form data-vv-scope="adjudge-form" @submit.prevent>
        <div class="row">
          <div class="col-8 m-auto text-right mb-3">
            <b-button
              variant="primary"
              @click="newBidderInAdjudge"
              size="sm"
              data-cy="new-adjudge-button"
            >
              <feather-icon
                icon="PlusIcon"
                size="12"
              />
              Nuevo adjudicatario
            </b-button>
          </div>
        </div>
        <div class="row">
          <div class="col-8 m-auto" v-if="showList">
           <span class="text-danger" v-if="!bidder">
            Por favor selecciona un adjudicatario de la lista
          </span>
            <vs-input
              label="Búsqueda de adjudicatario"
              autocomplete="off"
              data-vv-as="adjudicatario"
              :danger="errors.has('adjudge-form.adjudicatarioId')"
              :danger-text="errors.first('adjudge-form.adjudicatarioId')"
              class="w-100" v-model="bidderQuery" v-validate="{ required: true }"
              name="adjudicatarioId" v-on:keyup="searchForBidders()"
            />
            <span v-if="searching" class="muted-light">Buscando...</span>
            <ul data-cy="bidder-list" id="list" v-if="successfulBidders.length">
              <li
                style="cursor:pointer;"
                v-for="item in successfulBidders" @click="confirmBidder(item)"
                v-bind:key="item.adjudicatarioId"
              >
                <span>{{ item.nombre }}</span>
                <span class="muted-light">
                {{ item.rut }}
              </span>
                <p><b>{{ item.correo }}</b> ({{ item.ciudad }}, {{ item.comuna }})</p>
              </li>
            </ul>
            <small class="text-danger" v-if="error.adjudicatarioId">
              {{ error.adjudicatarioId }}
            </small>
          </div>
          <div v-if="bidder && !showList" class="col-8 m-auto" style="cursor:pointer;">
            <div v-on:click="showList=true">
              <small>
                Adjudicatario
              </small>
              <div>Nombre: <strong>{{ bidder.nombre }}</strong></div>
              <div>Rut: {{ bidder.rut }}</div>
            </div>
          </div>
          <div class="col-8 mt-3 m-auto">
            <vs-input
              label="Monto de adjudicación"
              class="w-100"
              v-model="amount"
              type="number"
              v-validate="{ required: true, regex: /^([0-9]+)$/ }"
              :danger="errors.has('adjudge-form.amount')"
              :danger-text="errors.first('adjudge-form.amount')"
              name="amount"/>
            <span class="text-primary" v-if="!bidder">
              Por favor ingresa un monto sin decimales
            </span>
          </div>
          <div class="col-8 mt-3 m-auto">
            <div class="mb-3 ml-2">
              <small >Fecha máxima de pago</small>
            </div>
            <b-form-group>
              <date-picker
                placeholder="Fecha máxima de pago"
                v-model="latestPaymentDate"
                class="w-100"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                name="latestPaymentDate"
                data-cy="fecha-maxima-pago"
              />
            </b-form-group>
          </div>
          <div class="col-12 text-center  mt-10">
            <b-button
              variant="success"
              @click="create()"
              data-cy="next-button"
            >
              Generar comprobante de adjudicación
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
    <b-modal
      title="Nuevo adjudicatario"
      no-close-on-backdrop
      ref="newBidderInAdjudge"
      size="sm"
      hide-footer
    >
      <NewBidderInAdjudgeForm v-on:bidder-save="handleBidderSave"/>
    </b-modal>
  </b-overlay>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';

import { selectedBatch } from '@/febos/aduanas/batches/store/getters';
import BatchFormField from '@/febos/aduanas/batches/views/components/BatchFormField';
// import { getSuccessfulBidders } from '@/febos/aduanas/successfulBidder/store/actions';
import { successfulBidders } from '@/febos/aduanas/successfulBidder/store/getters';
import NewBidderInAdjudgeForm from '@/febos/aduanas/batches/views/components/NewBidderInAdjudgeForm';

export default {
  name: 'BatchAdjudge',
  props: ['batch'],
  components: { BatchFormField, NewBidderInAdjudgeForm, DatePicker },
  data() {
    return {
      loading: false,
      bidderQuery: '',
      bidder: null,
      error: {},
      searching: false,
      showList: false,
      amount: null,
      latestPaymentDate: null
    };
  },
  watch: {
    bidder(newVal) {
      if (!newVal) {
        this.showList = true;
      }
    }
  },
  computed: {
    ...mapGetters('batches', {
      selectedBatch: selectedBatch.name
    }),
    ...mapGetters('successfulBidders', {
      successfulBidders: successfulBidders.name
    }),
  },
  methods: {
    ...mapActions('successfulBidders', ['getSuccessfulBidders']),
    ...mapActions('receipts', ['createNewReceipt']),
    formatDate(fullDate) {
      const parts = fullDate.split(' ')[0].split('-');
      const months = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
        'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ];
      return `${parts[2]} de ${months[parseInt(parts[1], 10)]}, ${parts[0]}`;
    },
    searchForBidders() {
      this.searchForBiddersByQuery(this.bidderQuery);
    },
    confirmBidder(item) {
      this.bidder = item;
      this.showList = false;
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async create() {
      const isValid = await this.validateForm('adjudge-form');
      if (!isValid) {
        return;
      }
      if (!this.bidder || !this.bidder.adjudicatarioId) {
        this.$vs.notify({
          title: 'Oops!',
          text: 'Por favor selecciona un adjudicatario de la lista',
          color: 'danger',
          time: 4000,
          position: 'top-center'
        });
        return;
      }

      if (this.amount < this.batch.montoMinimo) {
        this.$vs.notify({
          title: 'Oops!',
          text: 'Por favor coloca un monto superior o igual al monto mínimo del lote',
          color: 'danger',
          time: 4000,
          position: 'top-center'
        });
        return;
      }
      this.loading = true;
      const receipt = {
        subastaId: this.batch.subastaId,
        loteId: this.batch.loteId,
        adjudicatarioId: this.bidder.adjudicatarioId,
        monto: parseInt(this.amount, 10),
        fechaEmision: Vue.moment().format('YYYY-MM-DD'),
        fechaMaximaPago: this.latestPaymentDate
      };

      try {
        await this.createNewReceipt(receipt);
        this.$vs.notify({
          title: 'Genial!',
          text: 'Se ha adjudicado exitosamente',
          color: 'success',
          time: 4000,
          position: 'top-center'
        });
        this.loading = false;
        this.$emit('adjudge');
      } catch (e) {
        this.loading = false;
        this.$vs.notify({
          title: 'Oops!',
          text: 'Ocurrió un error al intentar hacer la acción',
          color: 'danger',
          time: 4000,
          position: 'top-center'
        });
      }
    },
    async searchForBiddersByQuery(query) {
      this.searching = true;
      await this.getSuccessfulBidders(
        {
          page: 1,
          items: 30,
          filters: `estadoActivo:1|content$${query}`,
          order: '+nombre'
        }
      );
      this.searching = false;
    },
    newBidderInAdjudge() {
      this.$refs.newBidderInAdjudge.show();
    },
    handleBidderSave(data) {
      this.$refs.newBidderInAdjudge.hide();
      const message = 'Adjudicatario guardado exitosamente';
      this.confirmBidder(data.adjudicatario);
      this.$bvToast.toast(
        message,
        {
          title: 'Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
    },
  },
  created() {
    this.showList = true;
    this.loading = false;
  }
};
</script>
<style scoped>
#list {
  background: pink;
  font-size: 12px;
  list-style: none;
  margin: 0;
  padding: 5px 0;
  background-color: white;
  border-radius: 0 0 5px 5px;
  border: 1px #ccc solid;
  border-top: none;
  z-index: 100;
  max-height: 140px;
  overflow-y: scroll;
}

#list li {
  display: block;
  padding: 5px 15px;
}

#list li:hover {
  background-color: #ccc;
  /*   color: white; */
}

#list li span {
  font-weight: 550;
}

#list li p {
  margin: 5px 0 0;
}

.muted-light {
  color: #aaa;
  font-weight: 100;
}

#search {
  border: solid 1px #ccc;
  width: 90px;
  padding: 3px;
}

#search:hover {
  background-color: #eee;
  cursor: pointer;

}
</style>

<style>
.mx-input {
  padding: 20px 10px 20px 35px;
  color: #6e6b7b;
}
.mx-icon-calendar {
  left: 10px
}
</style>
